'use client';

import { Component, ErrorInfo, PropsWithChildren } from 'react';
import OfflineContainer from '@/modules/error/containers/OfflineContainer';
import Error500 from '@/modules/error/components/Error500';

class ErrorsContainer extends Component<any, any> {
  constructor(props: PropsWithChildren<any>) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(/*error: any*/) {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.log('ErrorBoundary', { error, errorInfo });
    this.setState({ hasError: true });
  }

  render() {
    //این جا اگر صفحه ارور رندر شود تمام صفحه و بدون لیوت اصلی رندر میشود
    if (this.state?.hasError) {
      return (
        <Error500
          className="page-full"
          code="3"
          onClick={() => this.setState({ hasError: false })}
        />
      );
    }
    return <OfflineContainer>{this.props?.children}</OfflineContainer>;
  }
}

export default ErrorsContainer;
